// 航班预订
const FlightSearch = () => import(/* webpackChunkName: "flight-search" */ './pages/flight-search/App')
const Passenger = () => import(/* webpackChunkName: "passenger" */ './pages/passenger/App')
const ExtraFollowBook = () => import(/* webpackChunkName: "extra-book" */ './pages/extra-book/App')
const OrderPay = () => import(/* webpackChunkName: "order-pay" */ './pages/order-pay-new/App')
const OrderPayV1 = () => import(/* webpackChunkName: "order-pay-v1" */ './pages/order-pay/App')
const PayResult = () => import(/* webpackChunkName: "pay-result" */ './pages/pay-result-new/App')
const PayResultV1 = () => import(/* webpackChunkName: "pay-result-v1" */ './pages/pay-result/App')
// 单独辅营
const ExtraAloneEnter = () => import(/* webpackChunkName: "extra-ente" */ './pages/extra-enter/App')
const ExtraAloneValidate = () => import(/* webpackChunkName: "extra-validate" */ './pages/extra-validate/App')
const ExtraAloneBook = () => import(/* webpackChunkName: "extra-alone" */ './pages/extra-alone/App')
const ExtraAlonePay = () => import(/* webpackChunkName: "extra-pay-v1" */ './pages/extra-pay/App')
// 订单管理
const OrderV2Search = () => import(/* webpackChunkName: "order-v2-search" */ './pages/order-search-new/App')
const OrderV2Detail = () => import(/* webpackChunkName: "order-v2-detail" */ './pages/order-detail-new/App')
const AncillaryV2Search = () => import(/* webpackChunkName: "ancillary-v2-search" */ './pages/ancillary-search-new/App')
// 单独辅营详情页
const AncillaryV2Detail = () => import(/* webpackChunkName: "ancillary-v2-detail" */ './pages/ancillary-detail-new/App')
// 随票辅营详情页
const AncillaryV2SubDetail = () => import(/* webpackChunkName: "ancillary-v2-sub-detail" */ './pages/ancillary-sub-detail-new/App')
const ExtraaloneV2Pay = () => import(/* webpackChunkName: "extra-v2-pay" */ './pages/extra-pay-new/App')
// 国际票
const OrderIntlSearch = () => import(/* webpackChunkName: "order-intlSearch" */ './pages/order-search-new/App')
const AncillaryIntlSearch = () => import(/* webpackChunkName: "order-intlSearch" */ './pages/ancillary-search-new/App')
// 改升
const OrderChangeV2Search = () => import(/* webpackChunkName: "change-v2-search" */ './pages/change-search-new/App')
const OrderChangeV2Detail = () => import(/* webpackChunkName: "change-v2-detail" */ './pages/change-detail-new/App')
const OrderChangeV2Status = () => import(/* webpackChunkName: "change-v2-status" */ './pages/change-status-new/App')

const News = () => import(/* webpackChunkName: "news-list" */ './pages/news-list/App')
const NewsDetail = () => import(/* webpackChunkName: "news" */ './pages/news/App')
const Content = () => import(/* webpackChunkName: "content" */ './pages/content/App')
const Activity = () => import(/* webpackChunkName: "activity" */ './pages/activity/App')
const MembershipDay = () => import(/* webpackChunkName: "membership-day" */ './pages/activity-membership-day/App')

// 旅行服务
const FlightStatus = () => import(/* webpackChunkName: "flight-status" */ './pages/flight-status/App')
const RefundSearch = () => import(/* webpackChunkName: "refund-search" */ './pages/refundSearch/App')
const DelayProof = () => import(/* webpackChunkName: "delay-proof" */ './pages/delay-proof/App')
const SelfServiceChanges = () => import(/* webpackChunkName: "self-service-changes" */ './pages/self-service-changes/App')
const SelfServiceFeedback = () => import(/* webpackChunkName: "self-service-feedback" */ './pages/self-service-feedback/App')

const UsualPassenger = () => import(/* webpackChunkName: "usual-passenger" */ './pages/usualPassenger/App')
// const NotFound = () => import(/* webpackChunkName: "not-found" */ './pages/error/App')
// const Temp = () => import(/* webpackChunkName: "query-box" */ './pages/trip-box/App')
const UserCoupon = () => import(/* webpackChunkName: "usercoupon" */ './pages/usercoupon/App')
const TransferService = () => import(/* webpackChunkName: "transfer-service" */ './pages/transfer-service/App')
const epidemicsNoticeService = () => import(/* webpackChunkName: "epidemics-notice-service" */ './pages/transfer-service/App')
const biddingService = () => import(/* webpackChunkName: "bidding-service" */ './pages/transfer-service/App')
// 值机
const Checkin = () => import(/* webpackChunkName: "checkin" */ './pages/checkin/App')
const BoardingCard = () => import(/* webpackChunkName: "boardingCard" */ './pages/boardingCard/App')
const CheckinCancel = () => import(/* webpackChunkName: "checkinCancel" */ './pages/checkinCancel/App')
const CheckinRecrod = () => import(/* webpackChunkName: "checkinRecrod" */ './pages/checkinRecrod/App')
const CheckinSearch = () => import(/* webpackChunkName: "checkin-search" */ './pages/checkin-search/App')
const CheckinDetail = () => import(/* webpackChunkName: "checkin-detail" */ './pages/checkin-detail/App')
// 电子发票
const InvoiceValid = () => import(/* webpackChunkName: "invoice-valid" */ './pages/invoice-valid/App')
const InvoiceBook = () => import(/* webpackChunkName: "invoice-book" */ './pages/invoice-book/App')
const InvoiceCode = () => import(/* webpackChunkName: "invoice-code" */ './pages/invoice-code/App')
// 不正常航班证明
const DelaySegment = () => import(/* webpackChunkName: "delay-segment" */ './pages/delay-segment/App')
const DelayResponse = () => import(/* webpackChunkName: "delay-response" */ './pages/delay-response/App')
// 机票验真
const TicketVerify = () => import(/* webpackChunkName: "ticket-verify" */ './pages/ticket-verify/App')
// 代理人相关
const Pnr = () => import(/* webpackChunkName: "pnr" */ './pages/pnr/App')
const VirtualPoint = () => import(/* webpackChunkName: "virtual-point" */ './pages/virtual-point/App')
const AgentExport = () => import(/* webpackChunkName: "agent-export" */ './pages/self-agent-export/App')
// 旧订单相关
const OrderChangeSearch = () => import(/* webpackChunkName: "change-search" */ './pages/change-search/App')
const OrderChangeDetail = () => import(/* webpackChunkName: "change-detail" */ './pages/change-detail/App')
const OrderChangeStatus = () => import(/* webpackChunkName: "change-status" */ './pages/change-status/App')
const OrderSearch = () => import(/* webpackChunkName: "order-Detail" */ './pages/order-search/App')
const OrderDetail = () => import(/* webpackChunkName: "order-Detail" */ './pages/order-detail/App')
const AncillarySearch = () => import(/* webpackChunkName: "ancillary-search" */ './pages/ancillary-search/App')
const AncillaryDetail = () => import(/* webpackChunkName: "ancillary-detail" */ './pages/ancillary-detail/App')
const AncillarySubDetail = () => import(/* webpackChunkName: "ancillary-sub-detail" */ './pages/ancillary-sub-detail/App')
const OrderIntlSearch8L = () => import(/* webpackChunkName: "order-IntlSearch8L" */ './pages/order-intl-search/App')
const CardCoupon = () => import(/* webpackChunkName: "card-coupon" */ './pages/card-coupon/App')
// 二维码页面
const QRCodeModule = () => import(/* webpackChunkName: "qr-code" */ './pages/qr-code/App')

const IntlTicketBookingIndex = () => import(/* webpackChunkName: "intl-ticket-booking" */ './pages/intl-ticket-booking/App')
const IntlTicketBookingList = () => import(/* webpackChunkName: "intl-ticket-booking-list" */ './pages/intl-ticket-booking-list/App')
const IntlTicketBookingDetail = () => import(/* webpackChunkName: "intl-ticket-booking-detail" */ './pages/intl-ticket-booking-detail/App')
const IntlTicketBookingForm = () => import(/* webpackChunkName: "intl-ticket-booking-form" */ './pages/intl-ticket-booking-form/App')

export default [
  {
    path: '/',
    redirect: '/flight/search'
  },
  // 航班预订
  {
    path: '/flight/search',
    component: FlightSearch
  },
  {
    path: '/flight/passenger',
    component: Passenger
  },
  {
    path: '/extrafollow/book',
    component: ExtraFollowBook
  },
  {
    path: '/pay/v2/pay',
    component: OrderPay
  },
  {
    path: '/pay/v1/pay',
    component: OrderPayV1
  },
  {
    path: '/order/v2/payResult',
    component: PayResult
  },
  {
    path: '/order/payResult',
    component: PayResultV1
  },
  // 单独辅营
  {
    path: '/extraalone/enter',
    component: ExtraAloneEnter
  },
  {
    path: '/extraalone/validate',
    component: ExtraAloneValidate
  },
  {
    path: '/extraalone/book',
    component: ExtraAloneBook
  },
  {
    path: '/extraalone/pay',
    component: ExtraAlonePay
  },
  // 订单管理
  {
    path: '/order/v2/search',
    component: OrderV2Search
  },
  {
    path: '/order/v2/detail',
    component: OrderV2Detail
  },
  {
    path: '/order/detail',
    component: OrderDetail
  },
  {
    path: '/order/search',
    component: OrderSearch
  },
  {
    path: '/ancillary/v2/search',
    component: AncillaryV2Search
  },
  {
    path: '/ancillary/v2/detail',
    component: AncillaryV2Detail
  },
  {
    path: '/ancillary/v2/subDetail',
    component: AncillaryV2SubDetail
  },
  {
    path: '/ancillary/search',
    component: AncillarySearch
  },
  {
    path: '/ancillary/detail',
    component: AncillaryDetail
  },
  {
    path: '/ancillary/subDetail',
    component: AncillarySubDetail
  },
  {
    path: '/extraalone/v2/pay',
    component: ExtraaloneV2Pay
  },
  {
    path: '/order/intlSearch',
    component: OrderIntlSearch
  },
  {
    path: '/ancillary/intlSearch',
    component: AncillaryIntlSearch
  },
  {
    path: '/order/change/v2/search',
    component: OrderChangeV2Search
  },
  {
    path: '/order/change/v2/detail',
    component: OrderChangeV2Detail
  },
  {
    path: '/order/change/v2/status',
    component: OrderChangeV2Status
  },
  {
    path: '/order/change/search',
    component: OrderChangeSearch
  },
  {
    path: '/order/change/detail',
    component: OrderChangeDetail
  },
  {
    path: '/order/change/status',
    component: OrderChangeStatus
  },
  {
    path: '/help/:id',
    component: Content
  },
  {
    path: '/aboutus/:id',
    component: Content
  },
  {
    path: '/contactus/:id',
    component: Content
  },
  {
    path: '/article/:id',
    component: Content
  },
  {
    path: '/content/:id',
    component: Content
  },
  {
    path: '/menus/:type/:id',
    component: Content
  },
  {
    path: '/code/:type',
    component: QRCodeModule
  },
  {
    path: '/news',
    component: News,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/news/:id',
    component: NewsDetail
  },
  {
    path: '/activity/:id',
    component: Activity
  },
  {
    path: '/membershipDay',
    component: MembershipDay
  },
  {
    path: '/flight/status',
    component: FlightStatus
  },
  {
    path: '/flight/refund',
    component: RefundSearch
  },
  {
    path: '/service/delayProof',
    component: DelayProof
  },
  {
    path: '/service/selfChanges',
    component: SelfServiceChanges
  },
  {
    path: '/service/feedback',
    component: SelfServiceFeedback
  },
  {
    path: '/order/usualPassenger',
    component: UsualPassenger
  },
  // {
  //   path: '/tripBox',
  //   component: Temp
  // },
  {
    name: '404',
    path: '/404',
    beforeEnter: () => {
      // window.location.replace('/404')
      window.__MICRO_ROOT__?.router?.replace('/404')
    }
  },
  {
    path: '/usercoupon',
    component: UserCoupon
  },
  {
    path: '/tips/transfer',
    component: TransferService
  },
  {
    path: '/tips/epidemics',
    component: epidemicsNoticeService
  },
  {
    path: '/service/bidding',
    component: biddingService
  },
  {
    path: '/checkin',
    component: Checkin
  },
  {
    path: '/boardingCard',
    component: BoardingCard
  },
  {
    path: '/checkinCancel',
    component: CheckinCancel
  },
  {
    path: '/checkinRecrod',
    component: CheckinRecrod
  },
  {
    path: '/checkin/search',
    component: CheckinSearch
  },
  {
    path: '/checkin/detail',
    component: CheckinDetail
  },
  {
    path: '/invoice/valid',
    component: InvoiceValid
  },
  {
    path: '/invoice/book',
    component: InvoiceBook
  },
  {
    path: '/invoice/code',
    component: InvoiceCode
  },
  {
    path: '/delay/segment',
    component: DelaySegment,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/delay/response',
    component: DelayResponse
  },
  {
    path: '/ticketVerify',
    component: TicketVerify
  },
  {
    path: '/order/pnr',
    component: Pnr
  },
  {
    path: '/order/virtualPoint',
    component: VirtualPoint
  },
  {
    path: '/order/agentExport',
    component: AgentExport
  },
  {
    path: '/order/intlSearchV1',
    component: OrderIntlSearch8L
  },
  {
    path: '/cardcoupon',
    component: CardCoupon
  },
  {
    path: '/server/intlTicketBooking',
    component: IntlTicketBookingIndex
  },
  {
    path: '/server/intlTicketBookingList',
    component: IntlTicketBookingList
  },
  {
    path: '/server/intlTicketBookingDetail',
    component: IntlTicketBookingDetail
  },
  {
    path: '/server/intlTicketBookingForm',
    component: IntlTicketBookingForm
  }
]
